import React, { useEffect, useMemo } from 'react'
import styled from '@emotion/styled'
import { flatten } from 'lodash-es'
import { Tooltip } from '@ow/comps'
import arrowImg from '../../../assets/arrow.png'

const Box = styled.div`
  width: 28px;
  height: 28px;
  background: #ecf2fe;
  border: 1px solid #d4e3fc;
  border-radius: 100px 0 0 100px;
`

const NavMenu = function ({ navs, activeNavIndex, editableFields, onChange }) {
  const arr = useMemo(() => {
    return flatten(
      navs.map((item) => {
        const { content } = item
        if (content && content.children) {
          return [content, ...content.children]
        }
        return []
      })
    )
  }, [navs])

  useEffect(() => {
    if (editableFields.length === 0) {
      onChange(0)
    }
    let flag = 0
    const slugs = editableFields.map((v) => v.slug)
    if (slugs.length > 0 && arr.length > 0) {
      arr.forEach((s, index) => {
        if (s.fields && s.fields.children && flag === 0) {
          const _arr = s.fields.children.map((v) => v.slug)
          if (_arr.includes(slugs[0])) {
            flag = 1
            onChange(index)
          }
        }
      })
    }
  }, [editableFields])

  const isRender = useMemo(() => {
    const titles = []
    arr.forEach((v) => {
      if (v.title) {
        titles.push(v.title)
      }
    })
    return titles.length > 0
  }, [arr])

  if (!isRender) {
    return null
  }

  return (
    <Tooltip
      trigger={
        <Box className="mt-1 flex items-center justify-center cursor-pointer absolute right-0">
          <img src={arrowImg} alt="" className="w-3 h-3" />
        </Box>
      }
      style={{ padding: '0', background: '#fff' }}
      position="left top"
      on={['click']}
      arrow={null}
    >
      <div
        className="flex flex-col items-center cursor-pointer bg-white gap-2 py-2 max-h-96 overflow-y-auto"
        style={{
          Width: '120px',
          fontSize: '.75rem',
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.10)',
        }}
      >
        {arr.map((v, index) => {
          const { title } = v
          if (title) {
            return (
              <div
                key={index}
                className="w-full flex items-center"
                style={{
                  padding: '2px 15px',
                  borderLeft:
                    activeNavIndex === index
                      ? '2px solid #0152D9'
                      : '2px solid #fff',
                  color:
                    activeNavIndex !== index ? 'rgba(0,0,0,0.90)' : '#0152D9',
                  fontWeight: activeNavIndex === index && 'bold',
                }}
                onClick={() => {
                  onChange(index)
                }}
              >
                {title}
              </div>
            )
          }
          return null
        })}
      </div>
    </Tooltip>
  )
}

export default NavMenu
